import { httpGet, httpDel, httpPost } from '@/tool/request/index';

//获取批次顶部数据
export async function xcxBatchTop(baseId: string) {
  return await httpGet<API.RootResponse>('/batch/top')({
    params: {
      baseId,
    },
  });
}

//获取品种下拉框
export async function xcxBatchVarieties() {
  return await httpGet<API.RootResponse>('/xcx/batch/varieties')();
}

//根据品种与阶段获取规格
export async function xcxBatchSpec(params) {
  return await httpGet<API.RootResponse>('/xcx/batch/spec')({
    params,
  });
}

//获取批次分页数据
export async function xcxBatchPage(params) {
  return await httpGet<API.RootResponse>('/batch/page')({
    params,
  });
}

//获取批次分页数据
export async function xcxBatchXcxSystemTree(params) {
  return await httpGet<API.RootResponse>('/xcx/batch/xcxSystemTree')({
    params,
  });
}

//保存
export async function saveBatchSave(data: any) {
  console.log('保存三次', data);
  return await httpPost<API.RootResponse<any>>('/xcx/batch/save')({
    data,
  });
}

//修改
export async function saveBatchUpdate(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/update')({
    data,
  });
}

//批量新增养殖池投放记录
export async function saveBatchSveRecord(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/saveRecord')({
    data,
  });
}

//修改养殖池投放记录
export async function saveBatchUpdateRecord(data: any) {
  return await httpPost<API.RootResponse<any>>('/xcx/batch/updateRecord')({
    data,
  });
}

//确认投放
// export async function saveBatchConfirm(batchId: string) {
//   return await httpPost<API.RootResponse<any>>('/batch/confirm')({
//     params: {
//       batchId,
//     },
//   });
// }

export async function saveBatchConfirm(batchId: string) {
  return await httpPost<API.RootResponse<any>>(
    `/batch/confirm?batchId=${batchId}`
  )();
}

//分筛或出鱼获取鱼池信息
export async function xcxBatchGetFishpond(params) {
  return await httpGet<API.RootResponse>('/batch/getFishpond')({
    params,
  });
}

//根据批次id获取关联鱼池列表数据（下拉列表）
export async function xcxBatchFishpondList(params) {
  return await httpGet<API.RootResponse>('/batch/fishpondList')({
    params,
  });
}

//批次转移
export async function saveBatchTransfer(data: any) {
  return await httpPost<API.RootResponse<any>>('/xcx/batch/transfer')({
    data,
  });
}

//批次出鱼
export async function saveBatchShipping(data: any) {
  return await httpPost<API.RootResponse<any>>('/xcx/batch/shipping')({
    data,
  });
}

//删除批次
export async function xcxBatchDelete(batchId: string) {
  return await httpDel<any>('/batch/delete')({
    params: { batchId },
    isUrlQs: true,
  });
}

//删除养殖池投放记录
export async function xcxBatchDeleteRecord(recordId: string) {
  return await httpDel<any>('/batch/deleteRecord')({
    params: { recordId },
    isUrlQs: true,
  });
}

//获取出鱼列表
export async function xcxBatchShipping(params) {
  return await httpGet<API.RootResponse>('/batch/shipping')({
    params,
  });
}

//获取转移列表
export async function xcxBatchTransfer(params) {
  return await httpGet<API.RootResponse>('/batch/transfer')({
    params,
  });
}

//根据批次获取养殖记录列表(鱼池列表)投放
export async function xcxBatchGetRecord(params) {
  return await httpGet<API.RootResponse>('/batch/getRecord')({
    params,
  });
}

//获取转移明细列表
export async function xcxBatchTransferRecord(params) {
  return await httpGet<API.RootResponse>('/xcx/batch/transferRecord')({
    params,
  });
}

//获取出鱼明细列表
export async function xcxBatchShippingRecord(params) {
  return await httpGet<API.RootResponse>('/xcx/batch/shippingRecord')({
    params,
  });
}

// ----------------------------------------------------------6/11----------------------------------------------------

//获取品种下拉框列表
export async function varietyVarieties(type: any) {
  return await httpGet<API.RootResponse>('/variety/varieties?type=' + type)();
}

//根据品种与阶段获取规格
export async function varietySpec(params: any) {
  return await httpGet<API.RootResponse>('/variety/spec')({
    params,
  });
}

//新增批次获取可选基地车间树
export async function baseWorkshopTree(params: any) {
  return await httpGet<API.RootResponse>('/base/workshopTree')({
    params,
  });
}

//新增批次
export async function baseSave(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/save')({
    data,
  });
}

//获取检验分页数据
export async function xcxExaminingPage(params) {
  return await httpGet<API.RootResponse>('/examining/page')({
    params,
  });
}

// 通过系统id获取批次列表
export async function xcxBatchListBySystemId(systemId: string) {
  return await httpGet<API.RootResponse>(`/batch/${systemId}/batches`)();
}

//获取分筛出鱼列表
export async function baseFishpondList(batchId: any) {
  return await httpGet<API.RootResponse>(`/batch/transfer/fishponds`)({
    params: {
      batchId,
    },
  });
}

//获取分筛出鱼列表
export async function batchBatchFishponds(batchId: any) {
  return await httpGet<API.RootResponse>(`/batch/batch/fishponds`)({
    params: {
      batchId,
    },
  });
}

//保存分筛
export async function saveBatchSieving(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/transfer')({
    data,
  });
}

//修改分筛转移
export async function updateBatchSieving(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/updateTransfer')({
    data,
  });
}

//保存出鱼
export async function saveBatchSihipping(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/shipping')({
    data,
  });
}

//修改出鱼
export async function updateBatchSihipping(data: any) {
  return await httpPost<API.RootResponse<any>>('/batch/updateShipping')({
    data,
  });
}

//删除出鱼
export async function batchDelShipping(reportId: any) {
  return await httpDel<API.RootResponse>(
    `/batch/delShipping/report/${reportId}`
  )();
}

//删除分筛转移
export async function batchDelTransfer(reportId: any) {
  return await httpDel<API.RootResponse>(
    `/batch/delTransfer/report/${reportId}`
  )();
}


//通过批次获取鱼池
export async function batchFishpondByBatchId(batchId: string) {
  return await httpGet<API.RootResponse>(`/batch/batch/fishponds?batchId=${batchId}`)();
}